import React from 'react';
import { useTranslation } from 'react-i18next';

import { Body } from '@swyftx/aviary/atoms/Typography';

import { observer } from 'mobx-react-lite';
import { useMarginPositionDetails } from 'src/lib/margin/hooks/positions';

type Props = {
  positionId?: string;
};

const MarginPositionsTableType: React.FC<Props> = observer(({ positionId }) => {
  const { t } = useTranslation('margin');
  const { type } = useMarginPositionDetails({ positionId });

  if (!positionId) return null;

  return <Body>{t(`tradeType.${type}`)}</Body>;
});

export { MarginPositionsTableType };
